import type { AICopywriterRequestMessage } from '$lib/types/AICopywriter/api';
import type { AICopywriterPostChild } from '$lib/types/AICopywriter/types';
import type { MessageContent } from '@AlidaPackages/ailabs-client';
import { convertPostChildrenToBlocks } from '$lib/ai/post/utils/convertPostChildrenToBlocks';
import { Guid } from '@AlidaPackages/guid';

export const promptToCopywriterMessages = (
	prompt: string,
	postChildren?: AICopywriterPostChild[]
) => {
	// If an existing post is provided, it is converted to blocks and included in the message along with the prompt
	const blocks = postChildren ? convertPostChildrenToBlocks(postChildren) : [];
	const messageData = {
		prompt,
		...(blocks.length > 0 ? { post: { blocks } } : {}),
	} satisfies AICopywriterRequestMessage['text'];

	return [
		{
			id: new Guid(crypto.randomUUID()).toString(),
			type: 'json',
			dataType: 'message',
			text: JSON.stringify(messageData),
		},
	] satisfies MessageContent[];
};
